import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "alert_log",
  "use": "alert_log-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 17\" id=\"alert_log\"><g fill-rule=\"evenodd\"><path d=\"M9 6.29l-.25 5H7.21l-.21-5h2zm-1.75 7.4h1.51v-1.521H7.25v1.521zM2 15h12V5H2v10z\" /><path d=\"M11 1v1H5V1H3v1H0v15h16V2h-3V1h-2zm2 3V3h2v13H1V3h2v1h2V3h6v1h2z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id